/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast"
import { IAprovarSolicitacaoDto, ISd92Dto, sd92statusEnum } from "../../../Dtos/Comercial/Solicitacoes/SolicitacoesDtos"
import ApiService from "../../../Config/ApiConfig"
import LoadingPage from "../../../Components/Loading/Loading"
import AppLayout from "../../../Components/Layout/Layout"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { Fieldset } from "../../../Components/Fieldset/Fieldset"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import { InputData } from "../../../Components/Forms/InputData/InputData"
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import { UltAlt } from "../../../Components/UltAlt/UltAlt"
import { credencialTemAcesso } from "../../../Components/Layout/MenuData"
import { Select } from "../../../Components/Select/Select"
import styled from "styled-components"

export const FormSolicitacaoPage = () => {
    const { id } = useParams()

    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false)
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })
    const [formData, setFormData] = useState<ISd92Dto>({} as ISd92Dto)
    const [formDataAprovar, setFormDataAprovar] = useState<IAprovarSolicitacaoDto>({} as IAprovarSolicitacaoDto)
    const [isModalAprovarOpen, setIsModalAprovarOpen] = useState<boolean>(false)

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        if (id != null) buscarSolicitacaoPeloId()
    }, [])

    const buscarSolicitacaoPeloId = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd41 = await apiService.get<ISd92Dto>("/sd92Controller/buscarSolicitacaoPeloId", {
                params: {
                    'sd92id': id
                }
            })
            setFormDataAprovar(prev => ({ ...prev, sd92id: sd41.sd92id }))
            setFormData(sd41);
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar Solicitação! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    const converterStauts = (status: number) => {
        var nomeStatus = ""
        if (status === 0) nomeStatus = "SOLICITADO";
        if (status === 1) nomeStatus = "APROVADO";
        if (status === 2) nomeStatus = "RECUSADO"
        return nomeStatus
    }

    const converterMotivoSolicitacao = (status: number) => {
        var nomeStatus = ""
        if (status === 0) nomeStatus = "DEMONSTRACAO";
        if (status === 1) nomeStatus = "IMPLANTACAO";
        if (status === 2) nomeStatus = "OFICIAL"
        return nomeStatus
    }

    const handleAprovar = () => {
        setIsModalAprovarOpen(true)
    }

    const handleSubmitAprovar = async () => {
        try {
            if (formDataAprovar.status == null || formDataAprovar.status === '') {
                setToastOpcoes({ type: "info", visible: true, mensagem: "Selecione um status valido!" })
                return
            }

            if (formDataAprovar.sd92id == null) {
                setToastOpcoes({ type: "info", visible: true, mensagem: "Não foi carregado o ID da solicitação!" })
                return
            }

            const apiService = new ApiService()

            await apiService.post("/sd92Controller/alterarStatus", formDataAprovar)

            setIsModalAprovarOpen(false)
            buscarSolicitacaoPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: error.response.data })
        } finally {
            setLoading(false)
        }

    }

    const handleChangeAprovar = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormDataAprovar(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const toggleModalAprovar = () => {
        setIsModalAprovarOpen(prev => !prev)
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <PageTitle title='Solicitação' />
            <FormContainer>
                <Row style={{ gap: '15px' }}>
                    <Col>
                        <Row >
                            <Fieldset legend="Contrato">
                                <Row>
                                    <Col>
                                        <FormField >
                                            <Label>Código</Label>
                                            <Input
                                                type="text"
                                                name="sd92numcontrato"
                                                value={formData.sd92numcontrato?.toString() ?? ""}
                                                validation="numbers"
                                                disabled
                                            />
                                        </FormField>
                                    </Col>
                                    <Col>
                                        <InputData
                                            name="sd92dtcontrato"
                                            initialValue={formData.sd92dtcontrato}
                                            label="Data"
                                            disabled
                                        />
                                    </Col>
                                </Row>
                            </Fieldset>
                        </Row>
                        <Row style={{ marginTop: '25px' }}>
                            <Fieldset legend="Cliente Licenciado">
                                <Row>
                                    <FormField>
                                        <Label>Cliente</Label>
                                        <Input
                                            name="sd42cliente"
                                            value={`${formData.sd92cliente?.sd40cnpj ?? ""} - ${formData.sd92cliente?.sd40nome ?? ""}`}
                                            disabled
                                        />
                                    </FormField>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormField>
                                            <Label>Contato</Label>
                                            <Input
                                                name="sd42cliente"
                                                value={formData.sd92cliente?.sd40contato}
                                                disabled
                                            />
                                        </FormField>
                                    </Col>
                                    <Col md="2">
                                        <FormField>
                                            <Label>DDD</Label>
                                            <Input
                                                name="sd42cliente"
                                                value={formData.sd92cliente?.sd40ddd1}
                                                disabled
                                            />
                                        </FormField>
                                    </Col>
                                    <Col md="4">
                                        <FormField>
                                            <Label>Telefone</Label>
                                            <Input
                                                name="sd42cliente"
                                                value={formData.sd92cliente?.sd40fone1}
                                                disabled
                                            />
                                        </FormField>
                                    </Col>
                                </Row>
                                <Row>
                                    <FormField>
                                        <Label>E-mail</Label>
                                        <Input
                                            name="sd42cliente"
                                            value={formData.sd92cliente?.sd40email}
                                            disabled
                                        />
                                    </FormField>
                                </Row>
                            </Fieldset>
                        </Row>
                        <Row style={{ marginTop: '25px' }}>
                            <Fieldset legend="Representante">
                                <Row>
                                    <Col>
                                        <FormField>
                                            <Label>Representante</Label>
                                            <Input
                                                name="sd92aquisicao"
                                                value={`${formData.sd92representante?.sd41codigo} - ${formData.sd92representante?.sd41nome}`}
                                                disabled
                                            />
                                        </FormField>
                                    </Col>
                                </Row>
                            </Fieldset>
                        </Row>
                    </Col>
                    <Col >
                        <Row >
                            <Fieldset legend="Licenças">
                                <Row>
                                    <Col>
                                        <FormField>
                                            <Label>Solicitado para uso </Label>
                                            <Input
                                                name="sd92motivsolicitacao"
                                                value={converterMotivoSolicitacao(formData.sd92motivsolicitacao)}
                                                disabled
                                            />
                                        </FormField>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Fieldset legend="Formais">
                                            <Row>
                                                <Col>
                                                    <FormField>
                                                        <Label>Aquisição</Label>
                                                        <Input
                                                            name="sd92aquisicao"
                                                            value={formData.sd92aquisicao}
                                                            disabled
                                                            validation="numbers"
                                                        />
                                                    </FormField>
                                                </Col>
                                                <Col>
                                                    <FormField>
                                                        <Label>Locação</Label>
                                                        <Input
                                                            name="sd92locacao"
                                                            value={formData.sd92locacao}
                                                            disabled
                                                            validation="numbers"
                                                        />
                                                    </FormField>
                                                </Col>
                                            </Row>
                                        </Fieldset>
                                    </Col>
                                    <Col>
                                        <Fieldset legend="Provisória">
                                            <Row>
                                                <Col>
                                                    <FormField>
                                                        <Label>Qtd.</Label>
                                                        <Input
                                                            name="sd92quantidade"
                                                            value={formData.sd92quantidade}
                                                            disabled
                                                            validation="numbers"
                                                        />
                                                    </FormField>
                                                </Col>
                                                <Col>
                                                    <InputData
                                                        name="sd92dtprovisoria"
                                                        initialValue={formData.sd92dtprovisoria}
                                                        label="Data"
                                                        disabled
                                                    />
                                                </Col>
                                            </Row>
                                        </Fieldset>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '15px' }}>
                                    <Col>
                                        <Fieldset legend="SAMPalm">
                                            <Row>
                                                <Col>
                                                    <FormField>
                                                        <Label>Android</Label>
                                                        <Input
                                                            name="sd92sampalmandroid"
                                                            value={formData.sd92sampalmandroid}
                                                            disabled
                                                            validation="numbers"
                                                        />
                                                    </FormField>
                                                </Col>
                                                <Col>
                                                    <FormField>
                                                        <Label>IOs</Label>
                                                        <Input
                                                            name="sd92sampalmios"
                                                            value={formData.sd92sampalmios}
                                                            disabled
                                                            validation="numbers"
                                                        />
                                                    </FormField>
                                                </Col>
                                            </Row>
                                        </Fieldset>
                                    </Col>
                                </Row>
                            </Fieldset>
                        </Row>
                        <Row style={{ marginTop: '25px' }}>
                            <Fieldset legend="Sistemas">
                                <ScrollableTableContainer>
                                    <TableContainer>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <Th>Sigla</Th>
                                                    <Th>Sistema</Th>
                                                    <Th>Preço</Th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.sd921s?.map(sd921 => (
                                                    <tr key={sd921.sd921id}>
                                                        <Td>{sd921.sd921sistema.sd11sigla}</Td>
                                                        <Td>{sd921.sd921sistema.sd11descr}</Td>
                                                        <Td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(sd921.sd921sistema.sd11preco ?? 0)}</Td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </TableContainer>
                                </ScrollableTableContainer>
                            </Fieldset>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginTop: '25px' }}>
                    <Col>
                        <Fieldset legend="Situação">
                            <Row>
                                <Col md="2">
                                    <FormField>
                                        <Label>Status</Label>
                                        <Input
                                            name="sd92status"
                                            value={converterStauts(formData.sd92status)}
                                            disabled
                                        />
                                    </FormField>
                                </Col>
                                <Col md="10">
                                    <FormField>
                                        <Label>Motivo</Label>
                                        <Input
                                            name="sd92motivo"
                                            value={formData.sd92motivo}
                                            disabled
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                        </Fieldset>
                    </Col>
                </Row>
                {
                    formData.sd92status === sd92statusEnum.SOLICITADO && credencialTemAcesso("licenças", "sd031inclui") && (<Row style={{ marginTop: '15px' }}>
                        <Col>
                            <ButtonPrimary type="button" onClick={handleAprovar}>
                                Aprovar
                            </ButtonPrimary>
                        </Col>
                    </Row>)
                }
                <UltAlt>Ultima alteração: {formData.sd92du}</UltAlt>
            </FormContainer>


            <Modal isOpen={isModalAprovarOpen} toggle={toggleModalAprovar} centered>
                <ModalHeader toggle={toggleModalAprovar}>Bloqueio</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormField >
                                <Label>Status</Label>
                                <Select
                                    name="status"
                                    onChange={handleChangeAprovar}
                                >
                                    <option value="" >Selecione...</option>
                                    <option value={1} >Aprovar</option>
                                    <option value={2}>Recusar</option>
                                </Select>
                            </FormField>
                        </Col>
                        <Col>
                            <FormField >
                                <Label>Motivo</Label>
                                <Input
                                    type="text"
                                    name="motivo"
                                    value={formDataAprovar.motivo?.toString() ?? ""}
                                    onChange={handleChangeAprovar}
                                />
                            </FormField>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <ButtonPrimary type="button" onClick={handleSubmitAprovar}>
                        Salvar
                    </ButtonPrimary>
                </ModalFooter>
            </Modal>
        </AppLayout>
    )
}

const ScrollableTableContainer = styled.div`
  height: 300px; // Altura fixa
  overflow-y: auto; // Habilita a barra de rolagem vertical
  border: 1px solid #ccc; // Borda opcional para melhor visualização
  border-radius: 4px; // Borda arredondada
  box-shadow:  ${prop => prop.theme.sombras.padrao};
`;